import { render, staticRenderFns } from "./FieldsModal.vue?vue&type=template&id=21c82e9a&"
import script from "./FieldsModal.vue?vue&type=script&lang=js&"
export * from "./FieldsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports